export enum PageDateType {
    RandomDate = 1,
    ByPath = 2,
    CurrentDate = 3
}